import './App.css';
import Navbar from "./components/navbar/Navbar";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Home from "./screens/Home";
import Authors from "./screens/Authors";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./ScrollToTop";
import YoutubeScreen from "./screens/YoutubeScreen";
import Speech from "./screens/Speech";
import Teoria from "./screens/Teoria";

function App() {

return (
	<div className="App">
		<Router>
			<ScrollToTop/>
			<header>
				<Navbar/>
			</header>
			<Switch>
				<Route path='/' exact component={Home} />
				<Route path='/muzyka' component={YoutubeScreen} />
				<Route exact path='/dzwiek/teoria' component={Teoria} />
				<Route path='/dzwiek' component={Speech} />
				<Route path='/teoria' component={Teoria} />
				<Route path='/autorzy' component={Authors} />
			</Switch>
			<footer>
				<Footer/>
			</footer>
		</Router>
	</div>
);
}

export default App;
